import LoggerService from "@bfx/logger";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
const logger = LoggerService.for(__dirname);

/**
 * Create a handler that will output all changes (and optionally, accesses)
 * Logging of getters should generally not be used as usage in any view will result in the properties
 * being continually checked
 * @param target
 * @param logSetter
 * @param logGetter
 * @returns
 */
function createProxyHandler(
  target: any,
  type: string,
  logSetter: boolean,
  logGetter: boolean = false,
) {
  const propertyHandler = {
    set(obj, prop, value: any) {
      const oldValue = obj[prop];
      if (logSetter && oldValue !== value) {
        logger.out.info(`Button ${type}: ${prop} = ${value}`);
      }
      obj[prop] = value;
      return true;
    },

    get(obj, prop): any {
      if (logGetter) {
        logger.out.info(`Button ${type}: reading ${prop} = ${obj[prop]}`);
      }
      return obj[prop];
    },
  };
  return new Proxy(target, propertyHandler as any);
}

export class OEPanelActionsModel {
  public show_panel: boolean = true;
  public last_processed_event: any = null; // to be used for comparison
  public lock_controls: boolean = false; // for all
  public lockAllFg: boolean = false;
  public dataLoadingComplete = false;
  public saveDisabled = false;
  public submitClientIntent: CubiqTS.OrderIntent = null;
  public button_locks: {
    submit: boolean;
    clear: boolean;
    diApprove: boolean;
    diReject: boolean;
    diAbort: boolean;
    toleranceAccept: boolean;
    negativeMarkupAccept: boolean;
    modAccept: boolean;
    modReject: boolean;
    modAbort: boolean;
    trAccept: boolean;
    trReject: boolean;
    trAbort: boolean;
    edit: boolean;
    close: boolean;
    new: boolean;
    amCancel: boolean;
    amApprove: boolean;
    amReject: boolean;
    duplicate: boolean;
    copy: boolean;
    save: boolean;
    modifyAbort: boolean;
  } = {
    submit: false,
    clear: false,
    diApprove: false,
    diReject: false,
    diAbort: false,
    toleranceAccept: false,
    negativeMarkupAccept: false,
    modAccept: false,
    modReject: false,
    modAbort: false,
    trAccept: false,
    trReject: false,
    trAbort: false,
    edit: false,
    close: false,
    new: false,
    amCancel: false,
    amApprove: false,
    amReject: false,
    duplicate: false,
    copy: false,
    save: false,
    modifyAbort: false,
  };
  public button_visibility: {
    submit: boolean;
    clear: boolean;
    diApprove: boolean;
    diReject: boolean;
    diAbort: boolean;
    toleranceAccept: boolean;
    negativeMarkupAccept: boolean;
    modAccept: boolean;
    modReject: boolean;
    modAbort: boolean;
    trAccept: boolean;
    trReject: boolean;
    trAbort: boolean;
    edit: boolean;
    close: boolean;
    new: boolean;
    amCancel: boolean;
    amApprove: boolean;
    amReject: boolean;
    duplicate: boolean;
    copy: boolean;
    save: boolean;
    modifyAbort: boolean;
  } = {
    submit: true,
    clear: true,
    diApprove: true,
    diReject: true,
    diAbort: true,
    toleranceAccept: true,
    negativeMarkupAccept: true,
    modAccept: true,
    modReject: true,
    modAbort: true,
    trAccept: true,
    trReject: true,
    trAbort: true,
    edit: true,
    close: true,
    new: false,
    amCancel: true,
    amApprove: true,
    amReject: true,
    duplicate: true,
    copy: true,
    save: true,
    modifyAbort: true,
  };
  public button_labels: {
    clear: string;
    submit: string;
    copy: string;
    duplicate: string;
    edit: string;
    abort: string;
    reject: string;
    accept: string;
    force_reject: string;
    force_accept: string;
    accept_top: string;
    accept_down: string;
    approve: string;
    new: string;
    close: string;
    cancel: string;
    save: string;
    modifyAbort: string;
  } = {
    clear: "order_entry.button.clear", //'Clear',
    submit: "order_entry.button.submit", //'Submit',
    copy: "order_entry.button.copy", //'Copy',
    duplicate: "order_entry.button.duplicate", // 'Copy...',
    edit: "order_entry.button.edit", //'Edit',
    abort: "order_entry.button.abort", //'Abort',
    reject: "order_entry.button.reject", //'Reject',
    accept: "order_entry.button.accept", //'Accept',
    force_reject: "order_entry.button.force_reject", //'Reject',
    force_accept: "order_entry.button.force_accept", //'Accept',
    accept_top: "order_entry.button.accept_top", //'Accept Top',
    accept_down: "order_entry.button.accept_down", //'Accept Down',
    approve: "order_entry.button.approve", //'Approve',
    new: "order_entry.button.new", //'New'
    close: "order_entry.button.close", //'Close'
    cancel: "order_entry.button.cancel", //'Cancel'
    save: "order_entry.button.save",
    modifyAbort: "order_entry.button.abort", //'Abort',
  };

  public permissions: {
    submit: boolean;
  } = {
    submit: true,
  };

  constructor() {
    // this.button_visibility = createProxyHandler(this.button_visibility, "visibility", true);
    // this.button_locks = createProxyHandler(this.button_locks, "locks", true);
  }
}
